// material-ui
import Box from '@mui/material/Box';

// project imports
import NavUser from './NavUser';
import Navigation from './Navigation';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  return (
    <>
      {/* scrollable menu region — flex:1 + minHeight:0 lets it scroll inside the
          fixed full-height drawer paper while NavUser stays pinned at the bottom */}
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <Navigation />
      </Box>
      <NavUser />
    </>
  );
}
